import { NgModule, APP_INITIALIZER } from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppInit } from './app.init';
import { CSP_STYLE_PROVIDER } from './shared/csp-style.init';
import { Routing } from './app.routing';
import { AppSettings } from './app.settings';
import { AppComponent } from './app.component';
import { httpInterceptorProviders } from './interceptors/interceptors';

import { ServiceModule } from './services/service.module';

import { BlockUIModule } from 'ng-block-ui';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ThemeModule } from './theme/theme.module';
import { PipesModule } from './pipes/pipes.module';
import { PublicApiComponent } from './components/public-api.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SharedProductsModule } from './modules/shared/products.module';

import { NotSupportedComponent } from './components/not-supported/not-supported.component';

import { StoreModule } from '@ngrx/store';
import { reducers } from './app.reducers';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import arraySupport from 'dayjs/plugin/arraySupport';
import customParseFormat from 'dayjs/plugin/customParseFormat';

export function initApp(appInit: AppInit) {
  return () => appInit.init();
}

@NgModule({
  declarations: [
    AppComponent,
    PublicApiComponent,
    NotFoundComponent,
    NotSupportedComponent,
    // SearchResultsComponent
  ],
  exports: [ThemeModule, PipesModule],
  bootstrap: [AppComponent],
  imports: [
    SharedProductsModule,
    BrowserModule,
    BrowserAnimationsModule,
    ServiceModule.forRoot(),
    BlockUIModule.forRoot(),
    ThemeModule,
    PipesModule,
    NgbModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ToastrModule.forRoot(),
    Routing,
    NgSelectModule,
    FormsModule,
    StoreModule.forRoot(reducers),
  ],
  providers: [
    CSP_STYLE_PROVIDER,
    httpInterceptorProviders,
    AppSettings,
    AppInit,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AppInit],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor() {
    dayjs.extend(utc);
    dayjs.extend(arraySupport);
    dayjs.extend(customParseFormat);
  }
}
